// Renders a 1-bit bitmap ('#' = set pixel) so small UI glyphs stay pixel-crisp at any zoom.
const PixelGlyph = ({ rows, color = "black" }) => (
  <svg
    width={rows[0].length}
    height={rows.length}
    viewBox={`0 0 ${rows[0].length} ${rows.length}`}
    shapeRendering="crispEdges"
    fill={color}
    aria-hidden="true"
  >
    {rows.flatMap((row, y) =>
      [...row].map((c, x) =>
        c === "#" ? <rect key={`${x},${y}`} x={x} y={y} width="1" height="1" /> : null
      )
    )}
  </svg>
);

export default PixelGlyph;
